import React from 'react';
import PropTypes from 'prop-types';
import Select from '@deporvillage/select-component';
import { Config, formatPrice, I18nContext, StockLabel } from '@deporvillage/utils-library-component';

import styles from './BundledItemLine.module.scss';

const BundledItemLine = ({ item, update, error }) => {

    const { lang, featureFlags } = React.useContext(Config);
    const { translate } = React.useContext(I18nContext);

    const getVariantPrice = (itemMain) => {
        // @toDo FeatureFlag
        if (featureFlags?.enableNewAddToCart) {
            return itemMain.variants[0].items[
                itemMain.variants[0].items.findIndex((i) => i.uuid === (itemMain.selected || i.uuid))
                ].price;
        } else {
            return itemMain.variants[0].items[
                itemMain.variants[0].items.findIndex((i) => i.id == (itemMain.selected || i.id))
                ].price;
        }
    };

    // TODO refactor
    const [state, setState] = React.useState({
        ...item,
        prices: item.variants.length
            ? getVariantPrice(item)
            : item.default_variant.price,
    });

    const id = `${ item.id }-${ Math.floor(Math.random() * 999) }`;

    const variants = item.variants.map((v) => ({
        id: v.id,
        items: [
            {
                id: 0,
                name: translate(`product_page.sizing.choose_option`),
                selected: false,
                disabled: true,
                replenishment: true,
                price: { code: 'ES', pvp: 0, currency_code: 'EUR', price: 0 }
            },
            ...v.items,
        ],
    }));

    const changeSelect = (obj) => {
        let newState = {
            ...state,
            selected: obj.id,
            prices: obj.price,
        };

        // @toDo FeatureFlag
        if (featureFlags?.enableNewAddToCart) {
            newState = {
                ...state,
                selected: obj.uuid,
                prices: obj.price,
            };
        }

        setState(newState);
        update(newState);
    };

    return (
        <div className={styles['bundled-item-line-component']}>
            <div className={styles['bundle-item-line']}>
                <label htmlFor={id}>
                    {state.title}
                    <div className={styles['text-price']}>
                        {formatPrice(
                            state.prices.price,
                            state.default_variant.price.currency_code,
                            lang,
                        )}
                    </div>
                </label>
            </div>
            {variants.map((v) => (
                <div key={String(v.id)} className={styles['bundle-item-selector']}>
                    <Select
                        items={v.items.filter((f) => f.stockLabel !== StockLabel.NoStock || f.replenishment)}
                        default={0}
                        change={changeSelect}
                        error={error}
                        id={v.id}
                    />
                </div>
            ))}
        </div>
    );
};
BundledItemLine.propTypes = {
    update: PropTypes.func,
    error: PropTypes.array,
    item: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        name: PropTypes.string,
        defaultValue: PropTypes.bool,
        disabled: PropTypes.bool,
        default_variant: PropTypes.shape({
            price: PropTypes.shape({
                pvp: PropTypes.number,
                price: PropTypes.number,
                currency_code: PropTypes.string,
            }),
        }),
        selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        variants: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                items: PropTypes.array,
            })
        ),
    }),
};
export default BundledItemLine;
